import React from 'react'
import RenderFields from "../../../../common/ui/render-fields";
import {TEXT_PATH_FIELD_LIST} from "../../../constants/design.constant";

const EditRotationDetails = ({parentItem, handleRotationDetailsChanges}) => {

    return (
        <>

            <div className="ml-2 field-label">
                Rotation Degrees
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-28"
                            id="rotation"
                            name="rotation"
                            value={parentItem?.rotation}
                            onChange={(event) => {
                                handleRotationDetailsChanges(event, parentItem);
                            }}>
                        </input>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditRotationDetails
